// A dobra: caixa que desenrola animando `height` em px (auto não interpola) e itens que entram em cascata.
// Markup: .dobra[data-dobrada="true|false"] > .dobra-item. O CSS está em sass/shell/_layout.scss.
const $ = window.jQuery;

const Dobra = function () {

    const animar = function (caixa, dobrando) {
        if (!caixa) return;
        if (caixa.__solta) caixa.removeEventListener('transitionend', caixa.__solta);
        const antes = caixa.style.height;
        caixa.style.height = 'auto';
        const alvo = caixa.offsetHeight;
        caixa.style.height = antes;
        caixa.style.height = (dobrando ? alvo : 0) + 'px';
        void caixa.offsetHeight;
        caixa.style.height = (dobrando ? 0 : alvo) + 'px';
        caixa.__solta = ev => {
            if (ev.target !== caixa || ev.propertyName !== 'height') return;
            caixa.removeEventListener('transitionend', caixa.__solta);
            caixa.__solta = null;
            caixa.style.height = '';
        };
        caixa.addEventListener('transitionend', caixa.__solta);
    };

    // numera os itens de cada dobra (--i) para o atraso da cascata
    const numerar = function (raiz) {
        $(raiz).find('.dobra').addBack('.dobra').each(function () {
            const d = this;
            $(d).find('.dobra-item').filter((i, n) => $(n).closest('.dobra')[0] === d)
                .each((i, n) => n.style.setProperty('--i', i));
        });
    };

    // aberta: estado desejado
    const alternar = function (caixa, aberta) {
        animar(caixa, !aberta);
        caixa.dataset.dobrada = aberta ? 'false' : 'true';
    };

    return {
        init: function () {},   // só helpers; quem usa chama numerar/alternar
        animar: animar,
        numerar: numerar,
        alternar: alternar
    };
}();

module.exports = Dobra;
